var map = {
	"./advancis-logo.jpg": 405,
	"./dtek-logo.jpg": 170,
	"./lacar_logo.svg": 6127,
	"./lorne_logo.png": 5758,
	"./snibe-logo-1.jpg": 3757,
	"./testline-logo.png": 540,
	"./zentech-logo.png": 3419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2690;